import produce from 'immer';
import {
    LOGIN_SUCCESS,
    SET_IS_LOADING,
    SET_IS_SETTINGS_PANEL_OPEN,
    SET_IS_USER_MENU_EXTENDED
} from '../../Models/Constants/ActionTypes';
import { IAction } from '../../Models/Constants/Interfaces';
import { AppState } from './App.types';

export const defaultAppState: AppState = {
    isLoading: true,
    isUserLoggedIn: false,
    userName: 'Demo User',
    userUniqueObjectId: undefined,
    tenants: [],
    selectedTenantId: undefined,
    isUserMenuExpanded: false,
    isSettingsPanelOpen: false
};

export const AppReducer = produce((draft: AppState, action: IAction) => {
    const payload = action.payload;

    switch (action.type) {
        case LOGIN_SUCCESS:
            draft.userName = payload.userName;
            draft.userUniqueObjectId = payload.userUniqueObjectId;
            draft.tenants = payload.tenants;
            draft.selectedTenantId = payload.selectedTenantId;
            draft.isUserLoggedIn = true;
            break;
        case SET_IS_USER_MENU_EXTENDED:
            draft.isUserMenuExpanded = payload;
            break;
        case SET_IS_SETTINGS_PANEL_OPEN:
            draft.isSettingsPanelOpen = payload;
            break;
        case SET_IS_LOADING: 
            draft.isLoading = payload;
    }
}, defaultAppState);
